(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/rounds/views/rounds-tabs-content.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/rounds/views/rounds-tabs-content.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.rounds.views.RoundsTabsContent = Backbone.Marionette.View.extend({
    tagName: 'div',
    className: 'tab-content',
    id: 'roundsTabsContent',
    regionName: 'rounds-region-',
    template: function() {
      return '';
    },
    initialize: function() {
      var self = this;
      this.listenTo(this.collection, 'change:active', function(model, state) {
        var region = self.getRegion(self.regionName + model.cid);
        if (!state) {
          region.$el.removeClass('active');
        } else {
          region.$el.addClass('active');
        }
      });
    },
    reArrange: function(inputArray) {
      var reArrangedCollection = [];
      var rows = 0;

      if (inputArray.length > 9) {
        rows = 2;
      }
      if (inputArray.length >= 15) {
        rows = 3;
      }
      if (rows) {
        inputArray.forEach(function(item, i) {
          var row = i % rows;
          reArrangedCollection[row] = reArrangedCollection[row] || [];
          reArrangedCollection[row].push({
            row: row,
            item: item,
            first: i < rows
          });
        });
        reArrangedCollection = [].concat.apply([], reArrangedCollection);
      } else {
        reArrangedCollection = inputArray;
      }
      return [rows, reArrangedCollection];
    },
    onRender: function() {
      var self = this;
      this.collection.each(function(model, i) {
        var regionName = self.regionName + model.cid;
        var className = i === 0 ? ' tab-pane active' : ' tab-pane';

        self.$el.append('<div class="' +
            regionName +
            className +
            '" id="' +
            model.get('group') +
            '"></div>');
        self.addRegion(regionName, '.' + regionName);

        var roundItems = model.get('items');

        var reArrangedCollection = [];
        var rows = 0;
        var firstRowLength = 0;

        if (roundItems.length > 9) {
          rows = 2;
        }
        if (roundItems.length >= 15) {
          rows = 3;
        }

        if (rows) {
          roundItems.forEach(function(model, i) {
            var row = i % rows;
            reArrangedCollection[row] = reArrangedCollection[row] || [];
            reArrangedCollection[row].push(model);
          });

          firstRowLength = reArrangedCollection[0].length;

          reArrangedCollection.forEach(function(arr) {
            var firstModel = _.first(arr);
            firstModel.set('first', true);

            var lastModel = _.last(arr);
            lastModel.set('last', true);

            var arrLengthDiff = firstRowLength - arr.length;

            if (arrLengthDiff > 0) {
              for (var j = 0; j < arrLengthDiff; j++) {
                arr.push(new Backbone.Model({ empty: true }));
              }
            }
          });

          reArrangedCollection = new Backbone.Collection([].concat.apply([], reArrangedCollection));
        } else {
          reArrangedCollection = roundItems;
        }

        var roundContentItems = new svs.app.productStartPage.rounds.views.RoundsItems({
          collection: reArrangedCollection,
          type: 'columns',
          rows: rows
        });
        self.showChildView(regionName, roundContentItems);
      });
    }
  });
})(Backbone, _, svs);

 })(window);